import { useState } from "react";
import { Client } from "../../types/ganttChart";
import ConstraintListItemTitle from "./ConstraintListItemTitle";
import CitizenConstraintContent from "./CitizenConstraintContent";
import { formatCitizenAddress } from "../../service/citizenAddress";

const CitizenListItem = ({ citizen }: { citizen: Client }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div>
      <ConstraintListItemTitle
        title={citizen.description}
        subtitle={formatCitizenAddress(citizen)}
        isOpen={isOpen}
        onToggle={() => setIsOpen(!isOpen)}
      />

      {isOpen && (
        <CitizenConstraintContent
          clientId={citizen.idServiceClient}
          constraints={citizen.constraints ?? []}
        />
      )}
    </div>
  );
};

export default CitizenListItem;
